<div class="card-summary">
  <h1 class="card-summary__title text-base-font-primary" translate>structure.title</h1>

  <app-carousel [items]="data" (current)="onChange($event)">
    <ng-template let-slide>
      <div class="card-summary__image">
        <img loading="lazy" class="w-full" [src]="slide.imagem_mobile ?? slide.imagem_desktop" [alt]="slide.titulo" />
      </div>
    </ng-template>
  </app-carousel>

  <div class="card-summary__group" *ngIf="current$ | async as current">
    <div class="card-summary__info">
      <p>{{ current.titulo }}</p>
      <span> {{ current.chamada }}</span>
    </div>
  </div>
</div>
